"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfInvoicingDigestDto = instanceOfInvoicingDigestDto;
exports.InvoicingDigestDtoFromJSON = InvoicingDigestDtoFromJSON;
exports.InvoicingDigestDtoFromJSONTyped = InvoicingDigestDtoFromJSONTyped;
exports.InvoicingDigestDtoToJSON = InvoicingDigestDtoToJSON;
exports.InvoicingDigestDtoToJSONTyped = InvoicingDigestDtoToJSONTyped;
const OutstandingInvoiceDto_1 = require("./OutstandingInvoiceDto");
const InvoiceReconciliationDto_1 = require("./InvoiceReconciliationDto");
/**
 * Check if a given object implements the InvoicingDigestDto interface.
 */
function instanceOfInvoicingDigestDto(value) {
    if (!('payPeriodStart' in value) || value['payPeriodStart'] === undefined)
        return false;
    if (!('payPeriodEnd' in value) || value['payPeriodEnd'] === undefined)
        return false;
    if (!('invoices' in value) || value['invoices'] === undefined)
        return false;
    if (!('staleDrafts' in value) || value['staleDrafts'] === undefined)
        return false;
    if (!('unpaidInvoices' in value) || value['unpaidInvoices'] === undefined)
        return false;
    return true;
}
function InvoicingDigestDtoFromJSON(json) {
    return InvoicingDigestDtoFromJSONTyped(json, false);
}
function InvoicingDigestDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'payPeriodStart': (new Date(json['payPeriodStart'])),
        'payPeriodEnd': (new Date(json['payPeriodEnd'])),
        'invoices': (json['invoices'].map(InvoiceReconciliationDto_1.InvoiceReconciliationDtoFromJSON)),
        'staleDrafts': (json['staleDrafts'].map(OutstandingInvoiceDto_1.OutstandingInvoiceDtoFromJSON)),
        'unpaidInvoices': (json['unpaidInvoices'].map(OutstandingInvoiceDto_1.OutstandingInvoiceDtoFromJSON)),
    };
}
function InvoicingDigestDtoToJSON(json) {
    return InvoicingDigestDtoToJSONTyped(json, false);
}
function InvoicingDigestDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'payPeriodStart': ((value['payPeriodStart']).toISOString()),
        'payPeriodEnd': ((value['payPeriodEnd']).toISOString()),
        'invoices': (value['invoices'].map(InvoiceReconciliationDto_1.InvoiceReconciliationDtoToJSON)),
        'staleDrafts': (value['staleDrafts'].map(OutstandingInvoiceDto_1.OutstandingInvoiceDtoToJSON)),
        'unpaidInvoices': (value['unpaidInvoices'].map(OutstandingInvoiceDto_1.OutstandingInvoiceDtoToJSON)),
    };
}
//# sourceMappingURL=InvoicingDigestDto.js.map